import type { RoofYearQuoteFormInput } from 'app/home/create-quote/forms/property-details/roof-year/roof-year.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function roofYearQuoteFormSelector(store: QuoteDraftSelectorState): RoofYearQuoteFormInput {
  const roofYear = store.roofYear();
  const yearBuilt = store.yearBuilt();
  return { roofYear, yearBuilt };
}

export function roofYearQuoteFormValidationsSelector(store: QuoteFormOptionsSelectorState) {
  return store['roof-year']();
}
